import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-[#F5F2EB]/10 bg-[#0E0E0E] py-5"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((p, i) => (
          <span key={i} className="flex items-center gap-10 font-heading text-lg font-medium text-[#A8A29E]">
            {p}
            <span className="inline-block h-2 w-2 rotate-45 bg-[#E3AF4F]" />
          </span>
        ))}
      </div>
    </div>
  );
}
